export const PERMISSIONS = {
    assign:{
        value: 'assign',
        description: 'Assign a DDS report to a user'
    },
    approve:{
          value: 'approve',   
          description: 'Approve a DDS report'
    },
    worker:{
       value:'worker_in_worker',
       description:'Thsi is permission for indonesia worker which is under indonesia ptsi panel. It affect report visibility and filter'
    },
    can_create_farm: {
        value: 'can_create_farm',
        description: 'Create a farm'
    },
    can_update_farm: {
        value: 'can_update_farm',
        description: 'Update a farm'
    },
    can_delete_farm: {
        value: 'can_delete_farm',
        description: 'Delete a farm'
    },
    can_eudr_report_create_update: {
        value: 'can_eudr_report_create_update',
        description: 'Create and update EUDR report'
    }
}